import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from '../../util/reactIntl';

import { Modal } from '../../components';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import IconMenu from '../IconMenu/IconMenu';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';

import css from './DashboardMobileSidebar.module.css';

const DASHBOARD_MOBILE_SIDEBAR_ID = 'DashboardMobileSidebar';
const DASHBOARD_MOBILE_SIDEBAR_BUTTON_ID = 'dashboardMobileSidebarButton';

const DashboardMobileSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();

  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname, location.search, location.hash]);

  const handleManageDisableScrolling = (componentId, disableScrolling) => {
    dispatch(manageDisableScrolling(componentId, disableScrolling));
  };

  return (
    <div className={css.root}>
      <button
        id={DASHBOARD_MOBILE_SIDEBAR_BUTTON_ID}
        type="button"
        className={css.mobileDrawerMenu}
        onClick={() => setIsOpen(true)}
        aria-expanded={isOpen}
        aria-haspopup="dialog"
        aria-controls={DASHBOARD_MOBILE_SIDEBAR_ID}
        aria-label={intl.formatMessage({ id: 'DashboardMobileSidebar.openMenuAriaLabel' })}
      >
        <IconMenu />
        <span className={css.triggerLabel}>
          <FormattedMessage id="DashboardMobileSidebar.menuTrigger" />
        </span>
      </button>

      <Modal
        id={DASHBOARD_MOBILE_SIDEBAR_ID}
        className={css.drawerModal}
        scrollLayerClassName={css.drawerScrollLayer}
        containerClassName={css.drawerContainer}
        contentClassName={css.drawerContent}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        usePortal
        onManageDisableScrolling={handleManageDisableScrolling}
        focusElementId={DASHBOARD_MOBILE_SIDEBAR_BUTTON_ID}
        modalTitle={intl.formatMessage({ id: 'DashboardMobileSidebar.modalTitle' })}
      >
        <DashboardSidebar onNavigate={() => setIsOpen(false)} />
      </Modal>
    </div>
  );
};

export default DashboardMobileSidebar;
